import { Component, OnInit } from '@angular/core';

import { Alert, AlertType } from '../../classes/alert';
import { AlertService } from '../../services/alert.service';
import { flyInOut } from '../../classes/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    //moduleId: module.id,
    selector: 'app-flash-message',
    templateUrl: './flash-message.component.html',
    styleUrls: ['./flash-message.component.css'],
    animations: [flyInOut]
})
export class FlashMessageComponent implements OnInit {
    alerts: Alert[] = [];

    constructor(
        private alertService: AlertService,
        private sanitizer: DomSanitizer,
        private translate: TranslateService
    ) { }

    ngOnInit() {
        this.alertService.getAlert().subscribe((alert: Alert) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }

            /* marche pas très bien
            this.translate.get(alert.message)
            .subscribe(rt => {
                alert.message = rt;

                // add alert to array
                if (this.alerts.length > 0 && this.alerts[0].type === alert.type) {
                    let msg = '';
                    this.alerts.forEach(element => {
                        this.translate.get(element.message)
                        .subscribe(translation => {
                            msg +=  translation + '<br />';
                        });
                    });
                    alert.message = this.sanitizer.bypassSecurityTrustHtml(msg + alert.message);
                    this.alerts = [];
                }
                this.alerts.push(alert);
            }
            , ( error ) => {
                this.alerts.push(alert);
            });*/

            if (this.alerts.length > 0 && this.alerts[0].type === alert.type) {
                this.removeAlert(this.alerts[0]);
            }
            this.alerts.push(alert);


            // autoremove after [alert.removedAfter] milliseconds
            setTimeout(function () {
                if (this.alerts.length > 0) {
                    this.removeAlert(alert);
                }
            }.bind(this), alert.removedAfter);
        });
    }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    removeAlerts() {
        this.alerts = [];
    }

    cssClass(alert: Alert) {
        if (!alert) {
            return;
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'alert alert-success';
            case AlertType.Error:
                return 'alert alert-danger';
            case AlertType.Info:
                return 'alert alert-info';
            case AlertType.Warning:
                return 'alert alert-warning';
        }
    }
}
